import React from 'react';
import * as H1 from '../Helper/H1';
import Send from '../Helper/Send';
import { NavLink, useParams, useNavigate } from 'react-router-dom';
import { Panel, Input, Form, Divider, Message, Animation, Button } from 'rsuite';
import { PinchView } from 'react-pinch-zoom-pan'

import $ from "jquery";

function withParams(Component) {
    return props => <Component {...props} params={useParams()} navigation={useNavigate()} />;
}



let videoJsOptions = {
    languages: 'fa',
    autoplay: true,
    fluid: true,
    width: '200',
    controls: true,
};


export class My_Training extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            training_id: this.props.params.id,
            items: null,
            training_item: null,
            tr_vid: null,
            tr_vid_box: null,
            curent_item: null,
            step: 1,
            sub_arr: null,

            week: [

                {
                    name: 'شنبه',
                    slug: 'day_1',
                },
                {
                    name: 'یک شنبه',
                    slug: 'day_2',
                }
                ,
                {
                    name: 'دوشنبه',
                    slug: 'day_3',
                }
                ,
                {
                    name: 'سه‌شنبه',
                    slug: 'day_4',
                }
                ,
                {
                    name: 'چهارشنبه',
                    slug: 'day_5',
                },
                {
                    name: 'پنج‌شنبه',
                    slug: 'day_6',
                },
                {
                    name: 'جمعه',
                    slug: 'day_7',
                }

            ],
        };

    }


    // ---------------- componentDidMount--------------------------

    componentDidMount() {

        Send('page/my/training/' + this.state.training_id, "", true).then((res) => {


            if (!res.data.buyed) {
                this.props.navigation('/404');
            }




            this.setState({
                items: { ...res.data.items },
                training_item: res.data.training_item,
            }, () => {

                // console.log(this.state.items)
            })


        }).catch((err) => { });

        H1.NavHide();
    }



    // ---------------- componentWillUnmount--------------------------

    componentWillUnmount() {

        H1.NavShow();
    }



    //------------------ step_change-----------------------

    step_change = (id) => {

        this.setState({ step: id });

    }


    // ---------------- GetDay --------------------------

    GetDay = (theDay) => {

        this.setState({ curent_item: theDay });
        this.step_change(2)
    }


    // ---------------- GetVideo --------------------------

    GetVideo = (e) => {


       // $('video').click(function(){this.played ?? this.pause() })
       // $('video').play();

        console.log( e.target);


        if (e.target.paused) {
         e.target.play();
            
        }

        else{
          e.target.pause();
            
        }
        //e.get(0).pause();

    //     let videoJsOptions2 = {
    //         ...videoJsOptions,
    //         sources: [{ src: src}]
    //     };
    //    // this.setState({ video: videoJsOptions2 });

    //     console.log(videoJsOptions2);
    //     this.setState({ tr_vid: videoJsOptions2 });

    }


    // ---------------- GetVideo_Dismiss --------------------------

    GetVideo_Dismiss = () => {
        this.setState({ tr_vid: null });

    }




    // ---------------- GetVideoBox --------------------------

    GetVideoBox = (src) => {
        
        this.setState({ tr_vid_box: src });
    }






    render() {






        this.state.training && H1.page_name(this.state.training.name);

        return !this.state.items ? null : (


            <div className="h-100 mt-4 position-relative">




                {this.state.step === 1 &&
                    <>


                        <div className='c-row'>


                            <div className="text-center mb-2 py-2 position-relative">

                                <span className="icon-Back fs-3 position-absolute top-50 end-0 translate-middle-y" onClick={() => this.props.navigation(-1)}></span>


                            </div>


                        </div>





                        {this.state.items.length == 0 &&
                            <div className="c-row mt-4">


                                <Message showIcon type="info">
                                    درخواست رژیم غذایی شما درحال بررسی کارشناس میباشد. و پس از تکمیل شدن در همین بخش  قرار خواهد گرفت.
                                </Message>


                            </div>
                        }



                        {this.state.items &&

                            <div className="c-row mt-4">
                                <Animation.Slide in={true} placement="right">
                                    <>
                                        <div className='fs-3'> برنامه تمرینی </div>
                                        <div className="cc-2 mt-1">۳۰ روز</div>
                                    </>
                                </Animation.Slide>


                                {this.state.week.map((item, index) => [
                                    <Animation.Slide in={true} transitionAppear={true} placement="right" key={'info_'+index} >
                                        <div className={`archive_item d-flex flex-row br-16 mt-3 py-3 px-3 ${index == this.state.curent_item ? 'bb-1' : 'bg-white'}`} onClick={this.state.items[item.slug] && this.state.items[item.slug].length > 0 ? () => this.GetDay(item.slug) : null}>
                                            <div className="align-self-center index fs-24 cc-2 me-3 ltr "> {index < 9 && "0"}{index + 1}</div>
                                            <div className="align-self-center info">

                                                <span className={`fw-bold ${index == this.state.curent_item ? 'text-white' : ''}`}>  {item.name}</span>
                                                <div className="align-self-center time cc-2 fs-12 mt-1 text-start">
                                                    {this.state.items[item.slug] ? this.state.items[item.slug].length : 0} حرکت
                                                </div>


                                            </div>

                                            <div className={`align-self-center ms-auto play cursor ${this.state.items[item.slug] && this.state.items[item.slug].length > 0 ? 'cc-1' : 'cc-2'}`} >

                                                <span className="icon-Right rotate-180"></span>

                                            </div>

                                        </div>
                                    </Animation.Slide>
                                ])}
                            </div>
                        }



                    </>
                }



                {this.state.step === 2 &&
                    <>
                        <div className='c-row'>
                            <div className="text-center mb-2 py-2 position-relative">
                                <Animation.Bounce in={true}>
                                    <span className="icon-Back fs-3 position-absolute top-50 end-0 translate-middle-y" onClick={() => this.step_change(1)}></span>
                                </Animation.Bounce>
                            </div>
                        </div>




                        <div className="c-row mt-4">
                            <Animation.Slide in={true} placement="right" timeout={400}>
                                <>
                                    <div className='fs-3'> {this.state.week.filter(week => week.slug == this.state.curent_item)[0].name} </div>
                                    <div className="cc-2 mt-1">{this.state.items[this.state.curent_item].length} حرکت</div>
                                </>
                            </Animation.Slide>



                            {this.state.items[this.state.curent_item].map((item0, index0) => [
                                <div key={'row_' + item0.id}>

                                    {item0.length > 1 &&

                                        <div className='archive_item br-16 mt-3 bg-white' >
                                            <div className="No"> {index0 < 9 && "0"}{index0 + 1} </div>


                                            {item0.map((item, index) => [

                                                <Panel className='list_col' header={item.title} collapsible key={'panel_' + index}>

                                                    <div className="d-flex">

                                                        <div className="align-self-center index fs-24 cc-2 "> </div>

                                                        <div className="align-self-center info w-100">

                                                                                        
                                                        {item.title && this.state.training_item && this.state.training_item.find(({ name }) => name === item.title) &&

                                                            <div className='gif_place_holder br-16 w-100 mb-2'>

                                                                    {/* <img src={this.state.training_item.find(({ name }) => name == item.title).cover ?? null} width='100%' /> */}

                                                                    <video width="100%" height="auto" loop preload="none" muted onClick={(e) => this.GetVideo(e)} style={{ backgroundImage: `url("/img/play.png")` }}>
                                                                        <source src={this.state.training_item.find(({ name }) => name == item.title).video +'?' + item.id ?? null}  type="video/mp4" />
                                                                    </video>

                                                                    {this.state.training_item.find(({ name }) => name == item.title).dis}


                                                               
                                                                {/* <Button className='play_btn' appearance="default" onClick={() => this.GetVideo(this.state.training_item.find(({ name }) => name == item.title).video)}> <span className="icon-Search"></span></Button> */}

                                                            </div>
                                                        }

                                                        </div>

                                                    </div>


                                                    <div className="d-flex mt-2 align-items-stretch">
                                                        <div className="align-self-center cc-1 bb-gray-light br-16 text-center px-2 py-3 flex-fill">


                                                            {item.set && `${item.set} ست`}


                                                            <Divider vertical />

                                                            {item.count && `${item.count} تکرار`}


                                                            <Divider vertical />


                                                            {item.rest && `استراحت ${item.rest} ثانیه`}


                                                        </div>

                                                    </div>

                                                    {item.dis &&
                                                        <div className="d-flex mt-2 align-items-stretch">
                                                            <div className="align-self-center bb-gray-light br-16 p-3 flex-fill">
                                                                {item.dis}
                                                            </div>
                                                        </div>

                                                    }


                                                </Panel>

                                            ])}


                                        </div>

                                    }



                                    {!item0.length &&



                                        <div className='archive_item br-16 mt-3 bg-white' >
                                            <div className="No">{index0 < 9 && "0"}{index0 + 1} </div>

                                            <Panel className='list_col' header={item0.title} collapsible  >

                                                <div className="d-flex">

                                                    <div className="align-self-center info w-100">
                            
                                                            {item0.title && this.state.training_item && this.state.training_item.find(({ name }) => name === item0.title) &&

                                                                <div className='gif_place_holder br-16 w-100 mb-2'>
                                                                    {/*    <img src={this.state.training_item.find(({ name }) => name == item0.title).cover} width='100%' /> */}



                                                
                                                                    <video width="100%" height="auto" loop preload="none" muted onClick={(e) => this.GetVideo(e)} style={{ backgroundImage: `url("/img/play.png")` }}> 
                                                                        <source src={this.state.training_item.find(({ name }) => name == item0.title).video +'?' + item0.id ?? null}  type="video/mp4" />
                                                                    </video>

                                                                    {this.state.training_item.find(({ name }) => name == item0.title).dis}

{/*                                                                    
                                                                    <Button className='play_btn' appearance="default" onClick={() => this.GetVideo(this.state.training_item.find(({ name }) => name == item0.title).video)}> <span className="icon-Search"></span></Button>
                                                     */}
                                                                </div>
                                                            }

                                                    </div>
                                                </div>


                                                <div className="d-flex mt-2 align-items-stretch">
                                                    <div className="align-self-center cc-1 bb-gray-light br-16 text-center px-2 py-3 flex-fill">


                                                        {item0.set && `${item0.set} ست`}


                                                        <Divider vertical />

                                                        {item0.count && `${item0.count} تکرار`}


                                                        <Divider vertical />


                                                        {item0.rest && `استراحت ${item0.rest} ثانیه`}



                                                    </div>

                                                </div>

                                                {item0.dis &&

                                                    <div className="d-flex mt-2 align-items-stretch">
                                                        <div className="align-self-center bb-gray-light br-16 p-3 flex-fill">
                                                            {item0.dis}
                                                        </div>
                                                    </div>

                                                }



                                            </Panel>
                                        </div>

                                    }




                                </div>



                            ])}

                        </div>


                    </>
                }




            </div>

        )

    }
}

export default withParams(My_Training);
